
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

const ProjectNotFound: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <div className="container py-8">
      <div className="text-center">
        <h2 className="text-xl font-bold">Project not found</h2>
        <Button onClick={() => navigate('/projects')} className="mt-4">
          Back to Projects
        </Button>
      </div>
    </div>
  );
};

export default ProjectNotFound;
